function ForgotPassword() {
    const token = new URLSearchParams(window.location.search).get("token");
    console.log(token);
    window.location = `https://doctriscare.ml/_/#/users/confirm-password-reset/${token}`;
};

export default ForgotPassword;
